import {
    ApiServiceOrderBulkSelection,
    ApiServiceOrderBulkUpdatePreview,
    ApiServiceOrderBulkUpdatePreviewError,
    ApiServiceOrderBulkUpdatePreviewErrorCode,
    ApiServiceOrderPreview,
} from '../../types/serviceOrder/serviceOrderBulkUpdateApi.types';
import {
    ServiceOrderBulkUpdatePreview,
    ServiceOrderBulkUpdatePreviewError,
    ServiceOrderBulkUpdatePreviewErrorCode,
    ServiceOrderPreview,
} from '../../../serviceOrders/serviceOrders/serviceOrder.types';
import { parseOptionalStringDate } from '../../../sharedComponents/dateHelper';

export const mapToServiceOrderIds = (apiBulkSelection: ApiServiceOrderBulkSelection): string[] =>
    apiBulkSelection.order_ids;

export const mapToServiceOrderBulkUpdatePreviewErrorCode = (
    errorCode: ApiServiceOrderBulkUpdatePreviewErrorCode,
): ServiceOrderBulkUpdatePreviewErrorCode => {
    switch (errorCode) {
        case ApiServiceOrderBulkUpdatePreviewErrorCode.UNKNOWN_ORDER:
            return ServiceOrderBulkUpdatePreviewErrorCode.UNKNOWN_ORDER;
        case ApiServiceOrderBulkUpdatePreviewErrorCode.UNSUPPORTED_ORDER_TYPE:
            return ServiceOrderBulkUpdatePreviewErrorCode.UNSUPPORTED_ORDER_TYPE;
        case ApiServiceOrderBulkUpdatePreviewErrorCode.CANCELLED:
            return ServiceOrderBulkUpdatePreviewErrorCode.CANCELLED;
        case ApiServiceOrderBulkUpdatePreviewErrorCode.FINALIZED:
            return ServiceOrderBulkUpdatePreviewErrorCode.FINALIZED;
        case ApiServiceOrderBulkUpdatePreviewErrorCode.OTHER_SUPPLIER:
            return ServiceOrderBulkUpdatePreviewErrorCode.OTHER_SUPPLIER;
    }
};

export const mapToServiceOrderBulkUpdatePreviewError = (
    response: ApiServiceOrderBulkUpdatePreviewError,
): ServiceOrderBulkUpdatePreviewError => ({
    errorCode: mapToServiceOrderBulkUpdatePreviewErrorCode(response.error_code),
    orderIds: response.order_ids,
});

export const mapToServiceOrderPreview = (apiServiceOrderPreview: ApiServiceOrderPreview): ServiceOrderPreview => ({
    orderId: apiServiceOrderPreview.order_id,
    startedAt: parseOptionalStringDate(apiServiceOrderPreview.started_at),
    completedAt: parseOptionalStringDate(apiServiceOrderPreview.completed_at),
    generalInformation: apiServiceOrderPreview.general_information,
});

export const mapToServiceOrderBulkUpdatePreview = (
    apiServiceOrderBulkUpdatePreview: ApiServiceOrderBulkUpdatePreview,
): ServiceOrderBulkUpdatePreview => ({
    serviceOrders: apiServiceOrderBulkUpdatePreview.service_orders.map(mapToServiceOrderPreview),
    invalidOrders: apiServiceOrderBulkUpdatePreview.invalid_orders.map(mapToServiceOrderBulkUpdatePreviewError),
});
